import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';
import Dialog from '@zenbusiness/zui/Dialog';
import { useTheme } from '@zenbusiness/zui/styles';
import useMediaQuery from '@zenbusiness/zui/useMediaQuery';

const LOCALIZED_TEXT = {
  defaultTitle: 'orderView.heading'
};

const Modal = ({
  open, onClose, Content, taskData, type, task, title: titleProp
}) => {
  const { formatMessage: fm } = useIntl();
  const title = titleProp || fm({ id: LOCALIZED_TEXT.defaultTitle });
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog
      fullScreen={fullScreen}
      maxWidth="md"
      onClose={onClose}
      open={open}
    >
      <Content
        onClose={onClose}
        task={task}
        taskData={taskData}
        title={title}
        type={type}
      />
    </Dialog>
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  Content: PropTypes.elementType.isRequired,
  taskData: PropTypes.shape({}),
  task: PropTypes.shape({}),
  type: PropTypes.string.isRequired,
  title: PropTypes.string
};

export default Modal;
